import React from "react";
import {
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { useSelector } from "react-redux";

const DataTable = ({ columns = [], children, align = "left" }) => {
  const theme = localStorage.getItem("theme");
  const { allColors } = useSelector((state) => state);
  return (
    <TableContainer className="wallet_table">
      <Table
        stickyHeader
        aria-label="sticky table"
        sx={{
          borderCollapse: "separate",
          borderSpacing: "0px 3px", // horizontal, vertical gap
        }}
      >
        <TableHead>
          <TableRow>
            {columns.map((col, index) => (
              <TableCell
                key={index}
                align={align}
                sx={{
                  bgcolor:
                    theme === "dark"
                      ? allColors.tableHeaderColor
                      : allColors.lightTableHeaderColor,
                }}
              >
                {col}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody
          sx={{
            bgcolor:
              theme === "dark"
                ? allColors.tableBodyColor
                : allColors.lightTableBodyColor,
          }}
        >
          {children}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DataTable;
